import React, {useEffect, useState} from "react";
import './Header.css'
import MobileSmallHeader from "./MobileSmallHeader";
import {IConstants} from "../model/B2CInfo";
import {getMobileAppPromo} from "../../helpers/getMobileAppPromo";
import UserAvatar from "./Avatar";

interface IMobileHeaderProps {
    avatarUrl: string
    constants: IConstants
}

export default function MobileHeader(props: IMobileHeaderProps) {
    const [showFloatingHeader, setShowFloatingHeader] = useState(false);

    // @ts-ignore
    const handleScroll = (event) => {
        const scroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        if (scroll > 109) {
            setShowFloatingHeader(true)
        } else {
            setShowFloatingHeader(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    let promo = getMobileAppPromo(props.constants)

    return (
        <>
            <div className="Mobile_header">
                <div className="Mobile_header_top">
                    <img src="https://carsharing.s3.yandex.net/new_b2c_site/b2c_mobile_logo.png"
                         className="Mobile_header_logo"/>
                    <UserAvatar url={props.avatarUrl} styleClass={"Mobile_header_avatar"}/>
                </div>
                <div className="Mobile_header_links">
                    <a className="Mobile_header_link Mobile_header_link_selected" href={window.location.href}>
                        Каршеринг
                        <div className="Mobile_header_link_separator"/>
                    </a>
                    <a className="Mobile_header_link" href={props.constants.podpiska_link} target="_blank">Подписка</a>
                    <a className="Mobile_header_link" href={props.constants.b2b_link} target="_blank">Для бизнеса</a>
                </div>
                <div className="Mobile_header_separator"/>
            </div>
            {showFloatingHeader &&
            <MobileSmallHeader downloadIcon={promo.icon} downloadLink={promo.link} logo={props.constants.large_logo}/>}
        </>

    );
}